import React, {useState, useEffect} from 'react';
import {makeStyles} from '@material-ui/styles';
import {Card, CardContent,CardActions,CardHeader} from '@material-ui/core';
import {Typography,Button,Grid} from '@material-ui/core';
import './ordercard.css';

const useStyles = makeStyles({
    root:{
        minWidth: 275,
        backgroundColor: "primary",
    },
    title:{
        fontSize: 14,
    }
})

const OrderCard = (props) => {
    const classes = useStyles()
    const order_time = props.ready_time;
    const order_status = props.order_status;
    const description = props.description 
    const order_number = props.order_number;
    //const socket = props.socket;
    const [deleteMode,setdeleteMode] = useState(false);

    function orderClicked(){
        console.log("Order clicked"+order_number)
        setdeleteMode(!deleteMode);
        //socket.emit("add_new_order",)
        /*
        var msg = ""
        if (description){msg = " ("+description+")"}
        var res = window.confirm("Are you sure you wish to clear Order#"+order_number+msg)
        if (res){
            console.log("Remubhjvjhv order ", socket)
            socket.emit("remove",order_number)
        }*/

      }

      function remove(){

          if (deleteMode) {props.removeOrder(order_number)}
        
      }
      

    return (
        <Grid item xs ={12} sm={4}>
        <Card className = {classes.root} variant = "outlined" onClick={orderClicked}>
        <CardContent className = {order_status}> 
        <CardHeader 
            subheader = {order_time}
            title = {description}/>   
            {deleteMode ? <div><Typography>Are you sure you wish to clear this order?</Typography>
                <Button variant = "contained" color = "primary" onClick={remove}>REMOVE ORDER</Button><Button color = "secondary" variant = "contained" >CANCEL</Button> </div> :<div></div>}
                
        </CardContent>    
        </Card>
        </Grid>
    )
}


export default OrderCard;